// extracted by mini-css-extract-plugin
export default {"navBarDevider":"DashboardNavBar_navBarDevider__RssJ3"};